<template>
  <div
    :class="[ 'z-button', 'z-button--' + size, 'z-button--' + type,
      {'is-round': round, 'is-circle': circle, 'is-disabled': disabled, 'is-loading': loading }]"
    @click="emitClose($event)"
  >
    <i v-if="loading" class="el-icon-loading"></i>
    <i v-if="icon && !loading" :class="icon"></i>
    <span v-if="$slots.default">
      <slot />
    </span>
  </div>
</template>

<script>
export default {
  name: "ZeroButton",
  props: {
    size: { type: String, default: "small" },
    type: { type: String, default: "default" },
    round: { type: Boolean },
    circle: { type: Boolean },
    disabled: { type: Boolean },
    loading: { type: Boolean },
    icon: String
  },
  methods: {
    emitClose(event) {
      if (this.disabled || this.loading) return;
      this.$emit("click", event);
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/variables.scss";
.z-button {
  width: fit-content;
  font-size: 12px;
  user-select: none;
  border-radius: $radius-button;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 12px;
  box-sizing: border-box;
  cursor: pointer;
  // box-shadow: $shadow-primary;
  & + .z-button {
    margin-left: 10px;
  }
  // &:not(.z-button--circle) {
  //   padding: 0 24px;
  // }
  // &:active {
  //   // opacity: 0.6 !important;
  //   &:hover {
  //     opacity: 0.6;
  //   }
  // }
  &:hover {
    opacity: 0.8;
    &:active {
      opacity: 0.6;
    }
  }
  &.is-disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  &.is-loading {
    opacity: 0.6;
    cursor: not-allowed;
  }
  &.is-circle {
    border-radius: 50%;
  }
  &.is-round {
    border-radius: 20px;
  }
  &--big {
    height: 40px;
    padding: 0 20px;
    &.is-circle {
      width: 40px;
    }
  }
  &--medium {
    height: 36px;
    padding: 0 18px;
    &.is-circle {
      width: 36px;
    }
  }
  &--small {
    height: 32px;
    padding: 0 16px;
    &.is-circle {
      width: 32px;
    }
  }
  &--mini {
    height: 28px;
    padding: 0 14px;
    &.is-circle {
      width: 28px;
    }
  }
  &--smaller {
    height: 24px;
    padding: 0 12px;
    &.is-circle {
      width: 24px;
    }
  }
  &--smallest {
    height: 20px;
    padding: 0 10px;
    &.is-circle {
      width: 20px;
    }
  }
  &--default {
    color: $color-primary;
    background-color: $color-stripe;
  }
  &--primary {
    color: #fff;
    background-color: $color-primary;
  }
  &--warning {
    color: #fff;
    background-color: $color-warning;
  }
  &--danger {
    color: #fff;
    background-color: $color-danger;
  }
  &--info {
    color: #fff;
    background-color: $color-info;
  }
  &--success {
    color: #fff;
    background-color: $color-success;
  }
  &--round {
    border-radius: 40px;
  }
  > i {
    & + span {
      margin-left: 4px;
    }
  }
}
</style>